import React from "react";
import Main from "./pages/main";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "./assets/custom.css";
import { BrowserRouter } from "react-router-dom";
import Route from "./config/route";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Route />
      </BrowserRouter>
    </div>
  );
}

export default App;
